function Profile() {
    return (
        <div>
            <h1 className="text-2xl py-4">Profile</h1>
        </div>
    );
}

export default Profile;